var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: [
              "/work",
              "/complianceBusiness/EPRList",
              "/complianceBusiness/EPRDeclareList"
            ].includes(_vm.curUrl),
            expression:
              "['/work','/complianceBusiness/EPRList','/complianceBusiness/EPRDeclareList'].includes(curUrl)"
          }
        ],
        staticClass: "amz-btn",
        on: { click: _vm.openAmz }
      },
      [
        _c("img", {
          attrs: { src: require("@comp/images/common/amz_btn.png") }
        })
      ]
    ),
    _vm._v(" "),
    _vm.amzVisible
      ? _c("div", { staticClass: "amz-img" }, [
          _c("div", [
            _c("img", {
              attrs: {
                width: "540px",
                src: require("@comp/images/common/amz_img02.png")
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "amz-close-btn",
              on: { click: _vm.closeAmz }
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4de2650a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4de2650a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/module/components/amzPop.vue
// module id = null
// module chunks = 